import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '@/services/apiService';
import tenantPickerMixin from '@/components/core/tenant/pickerMixin';
import cloneDeep from 'lodash/cloneDeep';
import routerPaths from '@/router/paths';
import drawerLinksMixin from '@/components/core/drawerLinks';
export default {
  name: 'ViewAccountMgmtAccountMgmtDrawerLinks',
  mixins: [tenantPickerMixin, drawerLinksMixin],
  data: function data() {
    return {
      formIsValid: false,
      isSaving: false,
      tenantTheme: {}
    };
  },
  computed: {
    headerBG: function headerBG() {
      return './img/dtwin-factory1.png';
    },
    drawerIconLinks: function drawerIconLinks() {
      var _this = this;

      return routerPaths.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          name: _this.$i18n_t(item.name)
        });
      });
    }
  },
  watch: {
    selectedTenantId: function selectedTenantId() {
      if (this.selectedTenantId === undefined) {
        return;
      }

      var tenant = this.getTenantById(this.selectedTenantId);
      this.tenantTheme = tenant.data && tenant.data.theme || {};
      this.refreshDrawerLinks();
    }
  },
  mounted: function mounted() {
    this.loadTenants();
  },
  methods: {
    refreshDrawerLinks: function refreshDrawerLinks() {
      this.tenantTheme = cloneDeep(this.tenantTheme);
      this.processDrawerLinks();
    },
    resetDrawerLinks: function resetDrawerLinks() {
      this.tenantTheme.drawerLinks = null;
      this.refreshDrawerLinks();
    },
    createDrawerLinksConfig: function createDrawerLinksConfig() {
      this.tenantTheme.drawerLinks = [];
      this.refreshDrawerLinks();
    },
    defaultDrawerLinksConfig: function defaultDrawerLinksConfig() {
      this.tenantTheme.drawerLinks = cloneDeep(this.links);
      this.refreshDrawerLinks();
    },
    processDrawerLinks: function processDrawerLinks() {
      var doProcess = function doProcess(links) {
        links.forEach(function (linkItem) {
          if (linkItem.category && !linkItem.type) {
            linkItem.type = 'category';
          } else if (!linkItem.to && !linkItem.type) {
            linkItem.type = 'group';

            if (!linkItem.children) {
              linkItem.children = [];
            }
          } else if (linkItem.to && !linkItem.type) {
            linkItem.type = 'link';
          }

          if (!linkItem.permissionsJsonString) {
            linkItem.permissionsJsonString = JSON.stringify(linkItem.permissions || {}, null, 1);
          }

          if (linkItem.children) {
            doProcess(linkItem.children);
          }
        });
      };

      if (this.tenantTheme.drawerLinks) {
        doProcess(this.tenantTheme.drawerLinks);
      }
    },
    saveDrawerLinks: function saveDrawerLinks() {
      var _this2 = this;

      var doClean = function doClean(links, org) {
        (links || []).forEach(function (linkItem, index) {
          if (linkItem.type === 'category') {
            delete linkItem.permissionsJsonString;
            delete linkItem.permissions;
            delete linkItem.children;
          }

          if (linkItem.type === 'group') {
            delete linkItem.permissionsJsonString;
            delete linkItem.permissions;
            delete linkItem.type;
          }

          if (linkItem.type === 'link') {
            try {
              linkItem.permissions = JSON.parse(linkItem.permissionsJsonString);
            } catch (e) {
              org[index].permissionJsonError = e;
              _this2.formIsValid = false;
            }

            delete linkItem.permissionsJsonString;
            delete linkItem.children;
          }

          delete linkItem.type;

          if (linkItem.children) {
            doClean(linkItem.children, org[index].children);
          }
        });
      };

      var cleanedDrawerLinks = cloneDeep(this.tenantTheme.drawerLinks);
      doClean(cleanedDrawerLinks, this.tenantTheme.drawerLinks);

      if (!this.formIsValid) {
        this.refreshDrawerLinks();
        this.$snack('INVALID PERMISSION JSON', 'error');
        return;
      }

      this.isSaving = true; // Actually update the tenant

      return ApiService.tenantGetById(this.selectedTenantId, ['no-scope-descendents']).then(function (result) {
        var tenantObj = result;

        if (!tenantObj.data) {
          tenantObj.data = {};
        }

        tenantObj.data.theme = _objectSpread(_objectSpread({}, tenantObj.data.theme), {}, {
          drawerLinks: cleanedDrawerLinks
        });
        return ApiService.tenantUpdate(_this2, result);
      }).then(function () {
        // store saved theme data to tenant state
        var tenantIdx = _this2.getTenantIdxById(_this2.selectedTenantId);

        _this2.tenants[tenantIdx].data.theme = _this2.tenantTheme;

        _this2.refreshDrawerLinks();

        _this2.isSaving = false;

        _this2.$snack(_this2.$i18n_t('accMgmt.system.saveSucess'), 'success');
      }).catch(function (error) {
        console.error(error);

        if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this2.$snack(_this2.$i18n_t('accMgmt.system.errorSave'), 'error');
        }

        _this2.isSaving = false;
      });
    }
  }
};